"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var slugify_1 = require("../slugify");
/**
 * Utilitná funkcia pre konverziu textu do formátu vhodného napr. pre url odstránením nepovolených znakov
 * @param {text} - String pre konverziu
 * @returns {string} - Upravený text
 * @example
 * ```javascript
 * import keyify from 'utilities/lib/keyify';
 *
 * const text = 'Utilitné funkcie Sportnet Online';
 * console.log(keyify(text)); // utilitne-funkcie-sportnet-online
 * ```
 */
function keyify(text) {
    if (!text) {
        return '';
    }
    return slugify_1.default(text).replace(/[^a-z0-9]/g, '-');
}
exports.default = keyify;
